import axios from "axios";

export default {
  namespaced: true,
  state: {
    itemsubcategories: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    itemsubcategoriesMessage: ''
  },
  mutations: {
    RECEIVED_SUBCATEGORIES(state, payload) {
      state.itemsubcategories = payload;
      state.isReceiving = false;
    },
    RECEIVING_SUBCATEGORIES(state) {
      state.isReceiving = true;
    },
    RECEIVED_SUBCATEGORY(state, payload) {
      state = Object.assign(state, {
        itemsubcategories: [...state.itemsubcategories, payload],
        isReceiving: false,
      })
    },
    RECEIVING_SUBCATEGORY(state) {
      state.isReceiving = true;
    },
    UPDATED_SUBCATEGORY(state, payload) {
      console.log(state.itemsubcategories);
      console.log(payload);
      let index = state.itemsubcategories.findIndex(itemsubcategory => itemsubcategory._id === payload._id);
      state = Object.assign(state, {
        itemsubcategories: state.itemsubcategories.map((itemsubcategory, i) => {
          if (i === index) {
            return Object.assign({}, itemsubcategory, payload);
          }
          return itemsubcategory;
        }),
        isUpdating: false,
        itemsubcategoriesMessage: 'ItemSubcategories has been updating!',
      })
    },
    UPDATING_SUBCATEGORY(state) {
      state.isUpdating = true;
    },
    DELETED_SUBCATEGORY(state, payload) {
      let indexToDelete = state.itemsubcategories.findIndex(itemsubcategory => itemsubcategory._id === payload._id);
      console.log(indexToDelete);
      let itemsubcategories = [...state.itemsubcategories];
      itemsubcategories.splice(indexToDelete, 1);
      state = Object.assign(state, {
        itemsubcategories: [...itemsubcategories],
        isDeleting: false,
        idToDelete: null,
        itemsubcategoriesMessage: 'ItemSubcategory has been Deleted!',
      });
    },
    DELETING_SUBCATEGORY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getItemSubcategoriesRequest({dispatch}) {
      dispatch("receivingItemSubcategories");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/itemsubcategories';
      var header = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      return axios({ method: "get", url: url, headers: header }).then(response => {
        dispatch("receiveItemSubcategories", response.data);
      })
    },
    async updateItemSubcategoryRequest({dispatch}, payload) {
      dispatch("updatingItemSubcategory");
      var id = payload._id;
      delete payload['_id'];

      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/itemsubcategory/' + id;
      var header = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };

      return axios({ method: "put", url: url, headers: header, data: payload })
      .then(function (res) {
        dispatch("updateItemSubcategory", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateItemSubcategoryImageRequest({dispatch}, payload) {
      dispatch("updatingItemSubcategory");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);

      var url = 'https://api.tradexc.com:3000/update/itemsubcategory/image/' + id;
      data = new FormData();
      data.append('image', payload.itemsubcategoryimage, payload.imagename); 
      delete payload['itemsubcategoryimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("updateItemSubcategory", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createItemSubcategoryRequest({dispatch}, payload) {
      dispatch("receivingItemSubcategories");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.itemsubcategoryimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/itemsubcategory/withimage';
        data = new FormData();
        data.append('image', payload.itemsubcategoryimage, payload.imagename); 
        delete payload['itemsubcategoryimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.tradexc.com:3000/insert/itemsubcategory';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("receiveItemSubcategory", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteItemSubcategoryRequest({dispatch}, payload) {
      dispatch("deletingItemSubcategory", payload);
      console.log(payload);
      axios.get('https://api.tradexc.com:3000/delete/itemsubcategory/' + payload._id).then(() => {
        dispatch("deleteItemSubcategory", {_id: payload._id});
      })
    },
    receiveItemSubcategories({commit}, payload) {
      commit("RECEIVED_SUBCATEGORIES", payload)
    },
    receivingItemSubcategories({commit}) {
      commit("RECEIVING_SUBCATEGORIES")
    },
    receiveItemSubcategory({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_SUBCATEGORY", payload)
    },
    receivingItemSubcategory({commit}) {
      commit("RECEIVING_SUBCATEGORY")
    },
    updateItemSubcategory({commit}, payload) {
      commit("UPDATED_SUBCATEGORY", payload)
    },
    updatingItemSubcategory({commit}) {
      commit("UPDATING_SUBCATEGORY")
    },
    deleteItemSubcategory({commit}, payload) {
      commit("DELETED_SUBCATEGORY", payload)
    },
    deletingItemSubcategory({commit}, payload) {
      commit("DELETING_SUBCATEGORY", payload)
    }
  },
};
